var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex w-full" }, [
    _c(
      "div",
      { staticClass: "flex" },
      [
        [
          _c(
            "div",
            {
              staticClass:
                "mb-1 my-4 inline-flex flex-col items-center justify-center w-12 h-12 p-2.5 bg-blue-200 bg-opacity-40 rounded-lg",
            },
            [
              _c(
                "p",
                { staticClass: "text-xl font-bold text-center text-green-900" },
                [_vm._v(" " + _vm._s(_vm.itemNumber))]
              ),
            ]
          ),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }